import { Icon, IconProps } from '@amzn/awsui-components-core';
import { ContentRequestState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';

interface ContentRequestStatusProps {
  contentRequestState: ContentRequestState;
  assigneeName?: string;
}

const ContentRequestStatus = ({ contentRequestState, assigneeName }: ContentRequestStatusProps) => {
  let suggestionStatusText = '';
  // @ts-expect-error TS2322 - strict migration
  let iconName: IconProps.Name = null;
  let variant: IconProps.Variant = 'normal';

  switch (contentRequestState) {
    case ContentRequestState.REQUESTED:
      suggestionStatusText = 'Needs author';
      iconName = 'status-stopped';
      break;
    case ContentRequestState.ASSIGNED:
      suggestionStatusText = `Pending acceptance by ${assigneeName}`;
      iconName = 'status-pending';
      break;
    case ContentRequestState.ACCEPTED:
      suggestionStatusText = `Accepted by ${assigneeName}`;
      iconName = 'status-in-progress';
      break;
    case ContentRequestState.IN_PROGRESS:
      suggestionStatusText = assigneeName ? `In progress by ${assigneeName}` : 'In progress';
      iconName = 'status-in-progress';
      break;
    case ContentRequestState.REJECTED:
      suggestionStatusText = 'Rejected';
      iconName = 'status-negative';
      variant = 'error';
      break;
    case ContentRequestState.COMPLETED:
      suggestionStatusText = assigneeName ? `Completed by ${assigneeName}` : 'Completed';
      iconName = 'status-positive';
      variant = 'success';
      break;
  }

  return (
    <span className="suggestion-status">
      <Icon name={iconName} size="normal" variant={variant} /> &nbsp;{suggestionStatusText}
    </span>
  );
};

export default ContentRequestStatus;
